import { URGENCY_THRESHOLD_HOURS } from '../config';

/**
 Calculate remaining time between cut-off time and user's current time
 * @param {string} cutoffDateLocal - The local cut-off date.
 */
const calculateCutoffTime = (cutoffDateLocal: string): string => {

	if (!cutoffDateLocal) {

		return '';

	}

	const cutoffTime = new Date(cutoffDateLocal);

	if (Number.isNaN(cutoffTime.getTime())) {

		return cutoffDateLocal;

	}

	const now = new Date();
	const diffMs = cutoffTime.getTime() - now.getTime();
	const thresholdMs = URGENCY_THRESHOLD_HOURS * 60 * 60 * 1000;

	if (diffMs > 0 && diffMs < thresholdMs) {

		const totalMinutes = Math.ceil(diffMs / (1000 * 60));
		const hours = Math.floor(totalMinutes / 60);
		const minutes = totalMinutes % 60;

		const parts = [];
		if (hours > 0) {

			parts.push(`${hours} hr${hours > 1 ? 's' : ''}`);

		}

		parts.push(`${minutes} min${minutes !== 1 ? 's' : ''}`);

		return parts.join(' ');

	}

	// No urgency callout if the cutoff time is more than URGENCY_THRESHOLD_HOURS away or in the past
	return '';

};

export default calculateCutoffTime;
